import React from 'react';

const SearchIcon = () => {
  return (
    <svg
      width={27}
      height={24}
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1675 14H16.3023L15.9956 13.73C17.069 12.59 17.7151 11.11 17.7151 9.5C17.7151 5.91 14.528 3 10.5961 3C6.66419 3 3.47705 5.91 3.47705 9.5C3.47705 13.09 6.66419 16 10.5961 16C12.3594 16 13.9804 15.41 15.229 14.43L15.5247 14.71V15.5L21.0009 20.49L22.6328 19L17.1675 14ZM10.5961 14C7.86895 14 5.66753 11.99 5.66753 9.5C5.66753 7.01 7.86895 5 10.5961 5C13.3232 5 15.5247 7.01 15.5247 9.5C15.5247 11.99 13.3232 14 10.5961 14Z"
        fill="#515151"
      />
    </svg>
  );
};

export default SearchIcon;
